@if (open()) {
  <div class="modal-global__backdrop" (click)="onBackdropClick()">
<section
  class="modal-global"
  [attr.data-size]="size()"
  [attr.data-tone]="tone()"
  [attr.data-has-floating-content]="hasFloatingContent() ? 'true' : null"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title()"
      (click)="onDialogClick($event)"
      (keydown)="onDialogClick($event)"
    >
    <div class="modal-global__floating">
  <ng-content select="[modal-floating]"></ng-content>
</div>
      <header class="modal-global__header">
        <div class="modal-global__header-content">
          <h2 class="modal-global__title">{{ title() }}</h2>

          @if (description()) {
            <p class="modal-global__description">{{ description() }}</p>
          }
        </div>

        @if (showCloseButton()) {
          <button
            type="button"
            class="modal-global__close"
            aria-label="Fechar modal"
            (click)="close()"
          >
            ×
          </button>
        }
      </header>

      <div class="modal-global__body">
        <ng-content></ng-content>
      </div>

      @if (showFooter() && buttons().length > 0) {
        <footer class="modal-global__footer">
          @for (button of buttons(); track button.id) {
            <button
              type="button"
              class="modal-global__button"
              [attr.data-tone]="button.tone ?? 'primary'"
              [disabled]="button.disabled"
              [attr.aria-label]="button.ariaLabel ?? button.label"
              (click)="onButtonClick(button)"
            >
              @if (button.iconClass) {
                <i [class]="button.iconClass"></i>
              }

              <span>{{ button.label }}</span>
            </button>
          }
        </footer>
      }
    </section>
  </div>
}